export default defineNuxtRouteMiddleware((to) => {
  if (to.path !== '/') {
    const { query, hash } = to;
    const nextPath = '/';
    const nextRoute = { path: nextPath, query, hash };
    return navigateTo(nextRoute, { redirectCode: 301 });
  }
});
